module.exports = __webpack_public_path__ + "img/application_icon_fly_active.94b0efe3.png";